import React, { Component } from 'react';
import { Label } from 'semantic-ui-react'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import ControlsRenderer from '../../components/custom_controls_renderer'

class PlanControlTable extends Component {
  constructor(props){
    super(props);

    this.planColumns = [
      {
        dataField: 'preventative',
        text: 'Preventative Controls',
        formatter: (cell, row)=>this.formatControl(cell, row),
        headerTitle: true,
        editable: false
      },
      {
        dataField: 'recovery',
        text: 'Recovery Controls',
        headerTitle: true,
        editCellClasses: 'textarea-style',
        editable: false
      },
    ];
  }

  formatControl(control, row) {
    return <div className="cell-style" key={control.id}>{ control.item.name }
            <div style={{ paddingLeft: '10px' }}>{this.formatTags(control.item.tag_list)}</div>
          </div>
  }

  formatTags(tag_list) {
    if(tag_list.length == 0) {
      return []
    }
    const tags = tag_list.map((tag, index) => {
        return <Label>{ tag }</Label>
    })
    return <div>Tags: { tags }</div>
  }

  parseControls(controls) {
    if(controls.length == 0) {
      return []
    }

    const preventative = controls.preventative.map((control, index) => {
        return { preventative: control }
    })

    return preventative
  }

  render() {
    const { controls } = this.props;

    return (
      <BootstrapTable
        tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
        keyField="key"
        data={ this.parseControls(controls) }
        columns={ this.planColumns }
        striped
        hover
        condensed
        noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>No Risks have been selected.</span>}
      />
    )
  }
}

export default PlanControlTable;



// WEBPACK FOOTER //
// ./src/views/plan_tables/controls_table.js